import React from 'react';
import styles from './onlineForm.module.css';
import TextContainer from '../../../Atoms/CustomizedAtoms/TextContainer';

const ListOfAcademicRecords = ({ applicant, applicationData, column }) => {
  return (
    <div className={styles['personal-container']}>
      <div className={styles['personalsub-container']}>
        {applicant?.applications &&
        applicant?.applications[0]?.startYourApplication === 0 ? (
          <div className={styles['personalsubds-container']}>
            <div>
              <TextContainer
                title='List of any Advanced Courses Such As ‘A’ Levels, Ap, Clep, Ib Diploma'
                data={
                  applicationData?.applicantDetails &&
                  applicationData?.applicantDetails[0]?.listAdvancedCources
                }
                required={false}
                column={true}
              />
            </div>
            <div>
              <TextContainer
                title='If you are not currently enrolled in a school please describe your activities since you last attended'
                data={
                  applicationData?.applicantDetails &&
                  applicationData?.applicantDetails[0]?.activitiesNotEnrolled
                }
                required={false}
                column={true}
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ListOfAcademicRecords;
